import Dropdown from "tailwindcss-stimulus-components/src/dropdown"

export default class extends Dropdown {
}
